<template>
    <div class="animated fadeIn">
        <v-server-table :url="apiurl('sm/operation/table')"  :columns="columns" :options="options" :theme="theme" id="operationsTable" ref="operationsTable" class="table" >
            <a href="#" slot="cmd_delete" slot-scope="props" @click.prevent="cur=props.row; show_delete_modal=true">
                <i class="fa fa-times fa-lg text-danger"></i>
            </a>
            <router-link :to="{ path: '/admin/sm/operation/'+props.row.id }" slot="title" slot-scope="props" >
                {{props.row.title}}
            </router-link>
            <router-link :to="{ path: '/admin/sm/operation/'+props.row.id }" slot="slug" slot-scope="props" >
                {{props.row.slug}}
            </router-link>
        </v-server-table>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import {CONSTANTS} from '@/constants';

    Vue.use(ServerTable)

    export default {
        name: 'SmOperations',
        components: { ServerTable, Event },
        mixins: [functions, functions_loaders],
        data: function () {
            return {
                filterDisabled:null,
                columns:[ 'title', 'slug', 'type', 'color', 'line', 'state_from.title', 'func.state_to.title', 'cmd_delete'],
                options:{
                    saveState: true,
                    headings: {
                        id: '#',
                        title: 'переход',
                        slug: 'идентификатор',
                        type: 'тип',
                        //cmd_delete: function(h) { return <i class="fa fa-times fa-lg" title="удаление перехода"></i> },
                    },
                    sortable: ['title', 'slug'],
                    filterable: ['title', 'slug',],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: { chunk: 50, edge: false, nav: 'scroll', dropdown:false },
                    perPage:50,
                    perPageValues:[],
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    columnsClasses: {
                        cmd_delete: "center",
                        cmd_edit: "center",
                    },
                },
                theme: 'bootstrap4',
                template: 'default',
                show_delete_modal: false
            }
        },
        methods: {
            createState: function () {

            },
            deleteState: function () {

            },
            editState: function () {

            }
        },
        computed: {

        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        }
    }
</script>
